import React, { useState } from 'react';

import NewUser from './NewUser';

const Filter = ( props ) => {

  // VARIABLES DE ESTADO PARA MOSTRAR MODAL DE NUEVA ZONA Y FILTRO
  const [ newUserFormVisible, setNewUserFormVisible ] = useState( false );
  const [ filterString, setFilterString ] = useState( '' );

  // HANDLER PARA EL CAMBIO DE VALOR EN EL INPUT DE FILTRO
  const handleChange = ( event ) => {
    const value = event.target.value;
    setFilterString( value );

    props.filterChangeHandler( value );
  }

  // HANDLER PARA RELODEAR LISTA DE ZONAS AL CREAR UNA ZONA NUEVA
  const reloadUsers = () => {

    setNewUserFormVisible( false );

    props.reloadUsers();

  }

  // RENDERIZADO DE COMPONENTE
  return (
    <div className="filter">
      <div className="actions">
        <div className="search">
          <input name="user" placeholder='Search...' value={ filterString } onChange={ handleChange } />
        </div>
        <div className="options">
          {
            props.empresas.length
            ?
            <div className="newUser" onClick={ () => { setNewUserFormVisible( true ) } }>
              +
            </div>
            :
            null
          }
        </div>
      </div>


      <NewUser open={ newUserFormVisible } handlerClose={ () => { setNewUserFormVisible( false ) } } successHandler={ reloadUsers } empresas={ props.empresas } setEmpresas={ props.setEmpresas } userdata={ props.userdata } />
    </div>
  )
}

export default Filter
